import { render, staticRenderFns } from "./NoResultsFound.vue?vue&type=template&id=0a6f641d&scoped=true&"
import script from "./NoResultsFound.vue?vue&type=script&lang=js&"
export * from "./NoResultsFound.vue?vue&type=script&lang=js&"
import style0 from "./NoResultsFound.vue?vue&type=style&index=0&id=0a6f641d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6f641d",
  null
  
)

export default component.exports